import { MachineServices } from 'common/bento/types/MachineConfig';
import { apolloClient } from 'common/graphql/clients';

import { AbortApplicationDocument } from '../../../graphql/mutations/abortApplication.gql';
import { OnboardingCompanyDocument } from '../../../graphql/queries/onboardingCompany.gql';
import { SubmitKycApplicationDocument } from '../graphql/mutations/submitKycApplication.gql';
import { SubmitShineStartDocument } from '../graphql/mutations/submitShineStart.gql';
import { Model } from './model';

export enum Service {
  SubmitApplication = 'submitApplication',
  AbortApplication = 'abortApplication',
}

const services: MachineServices<Model, Service> = {
  abortApplication: async ({ getModuleData }) => {
    const { applicationTypeContext, companyContext } = getModuleData();

    if (!companyContext.companyProfileId) {
      throw new Error(`Can't call abortApplication without a companyProfileId`);
    }

    const { companyProfileId } = companyContext;

    await apolloClient.mutate({
      mutation: AbortApplicationDocument,
      variables: {
        input: {
          id: companyProfileId,
        },
      },
    });

    companyContext.clearCompanyContext();
    applicationTypeContext.dispatch(null);

    /**
     * To prevent any risk of stale data, we clear the apollo cache and refetch all active
     * queries after a reset. This is more or less equivalent to doing a browser refresh.
     */
    await apolloClient.resetStore();
  },
  submitApplication: async ({ getModuleData }) => {
    const { company, companyUser } = getModuleData().data.viewer;

    if (!company?.shineStart) {
      throw new Error(`shineStart required in submitApplication`);
    }

    if (!companyUser) {
      throw new Error(`companyUser required in submitApplication`);
    }

    await apolloClient.mutate({
      mutation: SubmitKycApplicationDocument,
      refetchQueries: [
        {
          query: OnboardingCompanyDocument,
          variables: { companyProfileId: company.companyProfileId },
        },
      ],
      variables: { input: { companyUserId: companyUser.companyUserId } },
    });

    await apolloClient.mutate({
      mutation: SubmitShineStartDocument,
      variables: { shineStartId: company.shineStart.shineStartId },
    });
  },
};

export default services;
